<app-graph [data]="graphData()" [options]="options()" type="bar"></app-graph>
